import { render, staticRenderFns } from "./DocumentSimpleNewOrEdit.vue?vue&type=template&id=13007742&scoped=true&"
import script from "./DocumentSimpleNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentSimpleNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSimpleNewOrEdit.vue?vue&type=style&index=0&id=13007742&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13007742",
  null
  
)

export default component.exports